import HttpClient from "../../services/HttpClient";
import Notification from "../../utils/Notification";

class DefaultSettingManager {

  constructor(httpClient = null) {
    this.httpClient = httpClient || new HttpClient()
    console.log(this.httpClient)
    this.url = `default-settings`
  }

  async create(componentState) {
    const { defaultSetting} = componentState
    try {
      const payload = {
        name:defaultSetting?.name,
        groups:defaultSetting?.groups,
        dimensions: defaultSetting?.dimensions,
        utm:defaultSetting?.utm,
        parametersets: defaultSetting?.parametersets,
        designerConfig: defaultSetting?.designerConfig,
        extendedDataSet: defaultSetting?.extendedDataSet,
        types: defaultSetting?.types
      }
      const res = await this.httpClient.post(this.url, payload);
      console.log("res success", res)
      if (res.status === 201) {
        new Notification()
          .setType("success")
          .setMessage(`${defaultSetting?.name} Default Setting created`)
          .send();
      }
      return res
    } catch (e) {
      if (e.message.includes("Conflict")) {
        new Notification()
          .setType("error")
          .setMessage(`The setting already exists for the selected groups or dimensions or experience`)
          .send();
      }
      console.log("failed to save Default Setting: ", e);
      return e;
    }
  }

  async getDefaultSetting(uuid) {
    try {
      const url = `${this.url}/${uuid}`;
      const res = await this.httpClient.get(url);
      console.log("res success", res)
      return res
    } catch (e) {
      console.log("failed to get Default Setting: ", e);
      return e
    }
  }

  async fetchAll(queryParams) {
    console.log("Default Setting manager fetchAll")
    try {
      const res = await this.httpClient.get(this.url, queryParams);
      if (res && res.results) {
        return res
      }
    } catch (e) {
      console.error("Failed to get Default Setting", e);
    }
    return null;
  }

  async fetchDefaultSetting(queryParams) {
    console.log("Fetching Default Setting")
    try {
      const url =`${this.url}/default`;
      const res = await this.httpClient.get(url, queryParams);
      if (res) {
        return res
      }
    } catch (e) {
      console.error("Failed to get Default Setting", e);
    }
    return null;
  }

  async fetchFilters (queryParams) {
    const url = '/sites/filters/defaultSettings'
    try {
      const res = await this.httpClient.get(url, queryParams);
      console.log("response in get request", res)
      if (res) {
        return res
      }
    } catch (e) {
      console.error("Failed to get defaultSettings", e);
    }
    return null;
  }

  async update(componentState,uuid) {
    console.log("update default Setting",uuid)
    const { defaultSetting,utmSelectState,qrConfigSelectState,parameterSetSelectState,extendedDataSetSelectStore} = componentState
    try {
      const payload = {
        name:defaultSetting?.name,
        groups:defaultSetting?.groups,
        dimensions: defaultSetting?.dimensions,
        utm: utmSelectState?.selected || null,
        parametersets: parameterSetSelectState.selected || null,
        designerConfig: qrConfigSelectState?.selectedConfig || null,
        extendedDataSet: extendedDataSetSelectStore?.selected || null,
        types: defaultSetting?.types
      }
      const url = `${this.url}/${uuid}`;
      const res = await this.httpClient.put(url, payload);
      if (res && !res?.error) {
        new Notification()
          .setType("success")
          .setMessage(`${defaultSetting?.name} Default Setting updated`)
          .send();
      }
      return res
    } catch (e) {
      console.log("failed to save Default Setting: ", e.message);
      if (e.message.includes("already exist")) {
        new Notification()
          .setType("error")
          .setMessage(`The setting already exists for the selected groups or dimensions or experience`)
          .send();
      }
      console.log("failed to save Default Setting: ", e);
      return e;
    }
  }

  async delete(state) {
    const {uuid} = state
    try {
      const url = `${this.url}/${uuid}`;
      const res = await this.httpClient.destroy(url);
      const response = {}
      response.status = res.status
      response.uuid = res.config.url.split("/").pop()
      return response
    } catch (e) {
      console.error("Failed to delete default setting", e.message)
    }
  }
}

export default DefaultSettingManager;
